import { Drawer } from "antd";
import SidebarItems from "./sidebarItems";

interface IProps {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (data: boolean) => void;
}

const RightDrawer = ({isDrawerOpen, setIsDrawerOpen}:IProps) => {
  return (
    <Drawer
    title="Menu"
      onClose={()=>setIsDrawerOpen(false)}
      open={isDrawerOpen}
      styles={{ body: { padding: "0%" } }}
      style={{ background: "#1D1F5D", color: "white" }}
      closable={true}
    >
      <SidebarItems/>
    </Drawer>
  );
};

export default RightDrawer;
